import Sidebar, { MobileTopbar } from "@/components/Sidebar";
import ChatWidget from "@/components/ChatWidget";
import CommandPalette from "@/components/CommandPalette";
import DemoBanner from "@/components/DemoBanner";
import { Outlet } from "react-router-dom";

export default function Layout() {
  return (
    <div className="min-h-screen bg-slate-50">
      <Sidebar />
      <MobileTopbar />
      <main className="md:pl-64">
        <DemoBanner />
        <div
          className="px-4 py-5 sm:px-6 sm:py-6 lg:px-8 lg:py-8 max-w-[1600px] mx-auto pb-28 md:pb-8"
          data-testid="main-content"
        >
          <Outlet />
        </div>
      </main>
      <CommandPalette />
      <ChatWidget />
    </div>
  );
}
